module.exports = __webpack_public_path__ + "static/media/smartphone-payment.2f86d261.jpg";